export const queryKeys = {
  me: ['me'] as const,
  status: ['status'] as const,
  wallet: ['wallet'] as const,
  ledger: (limit: number, offset: number) => ['wallet', 'ledger', limit, offset] as const,
  activeSession: ['instance-sessions', 'active'] as const,
  sessions: (limit: number, offset: number) => ['instance-sessions', 'list', limit, offset] as const,
  usageDaily: ['wallet', 'usage-daily'] as const,
  runs: (status?: string, limit?: number) => ['runs', status ?? 'all', limit ?? 50] as const,
  run: (id: number) => ['runs', id] as const,
  nomenclator: (term: string) => ['nomenclator', term] as const,
  /** Distinct from `nomenclator(term)` above (the /mapari correction search's
   *  key) — this is the paginated catalog browser/editor's list key (Plan 3d
   *  Task 3). Both share the `'nomenclator'` prefix so a single
   *  `invalidateQueries({ queryKey: ['nomenclator'] })` after a create/update/
   *  delete refreshes both caches. */
  nomenclatorList: (params: { search?: string; codBdMedoc?: string; codMedoc?: string; limit: number; offset: number }) =>
    ['nomenclator', 'list', params] as const,
  members: ['echipa', 'members'] as const,
  invitations: ['echipa', 'invitations'] as const,
  /** `['operator', 'organizations']` stays a valid *prefix* for invalidation
   *  (`useInvalidateOperatorOrgs` invalidates that shorter key, which
   *  fuzzy-matches every params-specific key below regardless of page/search). */
  operatorOrgs: (params: { limit: number; offset: number; q: string }) =>
    ['operator', 'organizations', params] as const,
  /** GET /operator/instances (Task 8) — cross-org active Fleet rentals. */
  operatorInstances: ['operator', 'instances'] as const,
};
